TokenView = require 'views/member/token-view'
View = require 'view'
templates = require 'views/internal/templates'

module.exports = class MemberApplicationsView extends View

  render: ->
    data = @model.toJSON(prefs: true)

    tokens = data.tokens ? []
    data.hasTokens = tokens.length > 0

    @$el.html(templates.fill('member_application_list', data))

    tokenViews = for token in tokens
      @subview(TokenView, @model, token, token.id)

    @appendSubviews tokenViews, @$('.js-list-member-applications')
    @



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-applications-view.coffee